export default "__VITE_ASSET__BpziJZVe__"